












import { Component, Vue, Prop } from 'vue-property-decorator';
import { CustomException } from '@/utils/error';

import { FitButton } from '@/fit-ui';
@Component({
  components: {
    FitButton,
  },
})
export default class LuanchWeApp extends Vue {
  @Prop() private btnText!: string;
  @Prop() private path!: string;
  @Prop() private username!: string;
  @Prop() private btnType!: 'button' | 'link'; // 显示类型：button、link，默认为button
  private htmlText = '';
  /**
     * 初始化打开app
     */
  private initLaunchWeAppText(calResult) {
    const path = this.path ? `path="${this.path}"` : '';
    return `<wx-open-launch-weapp id="launch-btn" ${path} username="${this.username}" style="width:${calResult.width}px;height:${calResult.height}px;">
            <template>
                <style >.wx-btn {border:none;display: block;opacity:0;width:${calResult.width}px;height:${calResult.height}px;min-height:${calResult.height}px}</style>
                <div class="wx-btn">跳转小程序</div>
            </template>
        </wx-open-launch-weapp>`;
  }
  private async mounted() {
    const calResult = this.getComputedStyle();// 计算宽高结果
    this.htmlText = this.initLaunchWeAppText(calResult);
    console.log('this.htmlText', this.htmlText);
    this.initEvent();
  }
  private initEvent() {
    const btn = document.getElementById('launch-btn');
    if (!btn) return;
    btn.addEventListener('launch', () => {
      this.$emit('onSuccess');
    });
    btn.addEventListener('error', (e) => {
      this.$emit('onError', e);
    });
  }
  private getComputedStyle() {
    const dom = document.getElementById('confirmBtn');
    if (!dom) {
      throw new CustomException(null, 'LaunchWeAppDomMissing', '找不到dom:confirmBtn');
    }
    return { width: dom.clientWidth, height: dom.clientHeight };
  }
}
